/**
 * Mobility Module - Entry Point
 *
 * @remarks
 * Módulo de Movilidad para gestión de transporte público,
 * rutas y ciclovías en WESTEER.
 * Auto-registro en el moduleRegistry al importarse.
 *
 * @module Mobility
 */

import { moduleRegistry } from '../../module-registry';
import { MobilityTabbedPanel } from './MobilityTabbedPanel';

// Module initialization
export {
  MobilityTabbedPanel,
} from './MobilityTabbedPanel';

export {
  initMobilityModule,
  isMobilityModuleRegistered,
  getMobilityDrawableTypes,
  MOBILITY_MODULE_METADATA,
} from './mobility.module';

// Types
export type {
  TransitStop,
  TransitStopType,
  TransitStopMetadata,
  CreateStopDto,
  UpdateStopDto,
  StopFilters,
  StopLabelOptions,
} from './types/stop.types';

export {
  getStopLabel,
  getStopTypeEmoji,
  getStopTypeName,
} from './types/stop.types';

// Services
export {
  mobilityApi,
  getMobilityApiErrorMessage,
} from './services/mobility-api';

// Hooks
export {
  useStops,
  type UseStopsState,
  type UseStopsActions,
  type UseStopsResult,
} from './hooks/useStops';

// Components
export { StopForm, type StopFormProps } from './components/StopForm';
export { StopPopup, type StopPopupProps } from './components/StopPopup';

// Constants
export {
  TRANSIT_STOP_DRAWABLE,
  TRANSIT_ROUTE_DRAWABLE,
  BIKEWAY_DRAWABLE,
  MOBILITY_DRAWABLE_TYPES,
} from './constants/drawable-types';

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

moduleRegistry.register({
  id: 'mobility',
  leftPanel: MobilityTabbedPanel,
  enabledByDefault: false,
});
